"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTestUsersProgressResponseToJSON = exports.GetTestUsersProgressResponseFromJSONTyped = exports.GetTestUsersProgressResponseFromJSON = void 0;
var _1 = require("./");
function GetTestUsersProgressResponseFromJSON(json) {
    return GetTestUsersProgressResponseFromJSONTyped(json, false);
}
exports.GetTestUsersProgressResponseFromJSON = GetTestUsersProgressResponseFromJSON;
function GetTestUsersProgressResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'usersProgress': (json['usersProgress'].map(_1.GetTestUsersProgressObjectFromJSON)),
        'owRewards': (json['owRewards'].map(_1.OWRewardFromJSON)),
    };
}
exports.GetTestUsersProgressResponseFromJSONTyped = GetTestUsersProgressResponseFromJSONTyped;
function GetTestUsersProgressResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'usersProgress': (value.usersProgress.map(_1.GetTestUsersProgressObjectToJSON)),
        'owRewards': (value.owRewards.map(_1.OWRewardToJSON)),
    };
}
exports.GetTestUsersProgressResponseToJSON = GetTestUsersProgressResponseToJSON;
